import React from 'react';

import { SliderData, Day, Hour } from './RoSliderHandle.styles';

const SliderHandle = props => (
  <SliderData id={`roHandle_${props.id}`}>
    <Day>{props.day}</Day>
    <Hour>{props.hour}</Hour>
  </SliderData>
);

export default SliderHandle;
